module.exports = __webpack_public_path__ + "img/logo.ff75860d.svg";